import { BotFlow, TelephonyChannelSchema } from '@feedyou/schema'

export function getTelephonyChannel(flow?: BotFlow): TelephonyChannelSchema | undefined {
  return flow?.channels?.find(channel => channel.type === 'telephony') as
    | TelephonyChannelSchema
    | undefined
}
